export const STARTER_OFFICE_LIMIT_REACHED_MESSAGE =
  "Your Starter plan is limited to one office. Your team already reached this limit.";

export const STARTER_SLOT_CONSUMED_EMPTY_LOBBY_MESSAGE =
  "Your team already reached the Starter plan limit of one office. Ask your tenant admin to invite you to the offices you need.";

export const STARTER_DEFAULT_OFFICE_ONLY_MESSAGE =
  "Starter plan users can only access and manage the default office. Ask your tenant admin for a paid license to use this office.";

export const STARTER_DEFAULT_OFFICE_ONLY_SCREEN_BODY =
  "Your Starter plan only includes access to the default office. Ask your tenant admin for a paid license if you need to access this office.";
